<mat-form-field
  appearance="fill"
  class="mat-form-field--no-label mat-form-field--no-errors"
  data-cy="select-category-filter">
  <mat-select
    (selectionChange)="updated($event)"
    [(ngModel)]="categoryId"
    class="select-category-filter"
    panelClass="select-category-panel">
    <mat-option
      [value]="''">
      {{'All categories' | translate}}
    </mat-option>
    <mat-option
      *ngFor="let category of categories$ | async"
      [value]="category.id">
      {{category.name}}
    </mat-option>
  </mat-select>
</mat-form-field>
